import React from "react";
import TextContent from "../shared/TextContent";
import { Popup } from "semantic-ui-react";
import { headerText, helpText } from "./Resources";
import TextareaAutosize from "react-textarea-autosize";

export const Attributes = (props) => {
  const {
    id,
    type,
    label,
    step,
    doneStep,
    item,
    item: { attributes, doneList },
    setItem,
    saveItem,
    itemTemplate,
  } = props;

  const editAttributes = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      doneList: {
        ...doneList,
        attributes: false,
      },
    });
  };

  const setAttributesDefinition = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      attributes: {
        ...attributes,
        definition: event.target.value,
      },
    });
  };

  const toggleAttributesPersonalities = (personality) => {
    let personalitiesUpdate = [...attributes.personalities];
    let personalitiesOtherUpdate = attributes.personalitiesOther;
    const personalitiesIndex = attributes.personalities.indexOf(personality);
    if (personality === "any personalities" && personalitiesIndex === -1) {
      personalitiesUpdate = [];
      personalitiesOtherUpdate = [];
    } else if (attributes.personalities.indexOf("any personalities") !== -1) {
      personalitiesUpdate.splice(0, 1);
    }
    if (personalitiesIndex === -1) {
      personalitiesUpdate.push(personality);
    } else {
      personalitiesUpdate.splice(personalitiesIndex, 1);
    }
    setItem({
      ...item,
      attributes: {
        ...attributes,
        personalities: personalitiesUpdate,
        personalitiesOther: personalitiesOtherUpdate,
      },
    });
  };

  const setAttributesPersonalitiesOther = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      attributes: {
        ...attributes,
        personalities:
          attributes.personalities.indexOf("any personalities") !== -1
            ? []
            : [...attributes.personalities],
        personalitiesOther: event.target.value,
      },
    });
  };

  const clearAttributesPersonalitiesOther = () => {
    setItem({
      ...item,
      attributes: {
        ...attributes,
        personalitiesOther: [],
      },
    });
  };

  const toggleAttributesAge = (age) => {
    let agesUpdate = [...attributes.ages];
    let agesOtherUpdate = attributes.agesOther;
    const agesIndex = attributes.ages.indexOf(age);
    if (age === "any age" && agesIndex === -1) {
      agesUpdate = [];
      agesOtherUpdate = [];
    } else if (attributes.ages.indexOf("any age") !== -1) {
      agesUpdate.splice(0, 1);
    }
    if (agesIndex === -1) {
      agesUpdate.push(age);
    } else {
      agesUpdate.splice(agesIndex, 1);
    }
    setItem({
      ...item,
      attributes: {
        ...attributes,
        ages: agesUpdate,
        agesOther: agesOtherUpdate,
      },
    });
  };

  const setAttributesAgesOther = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      attributes: {
        ...attributes,
        ages:
          attributes.ages.indexOf("any age") !== -1 ? [] : [...attributes.ages],
        agesOther: event.target.value,
      },
    });
  };

  const clearAttributesAgesOther = () => {
    setItem({
      ...item,
      attributes: {
        ...attributes,
        agesOther: [],
      },
    });
  };

  const toggleAttributesGender = (gender) => {
    let gendersUpdate = [...attributes.genders];
    let gendersOtherUpdate = attributes.gendersOther;
    const gendersIndex = attributes.genders.indexOf(gender);
    if (gender === "any gender" && gendersIndex === -1) {
      gendersUpdate = [];
      gendersOtherUpdate = [];
    } else if (attributes.genders.indexOf("any gender") !== -1) {
      gendersUpdate.splice(0, 1);
    }
    if (gendersIndex === -1) {
      gendersUpdate.push(gender);
    } else {
      gendersUpdate.splice(gendersIndex, 1);
    }
    setItem({
      ...item,
      attributes: {
        ...attributes,
        genders: gendersUpdate,
        gendersOther: gendersOtherUpdate,
      },
    });
  };

  const setAttributesGendersOther = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      attributes: {
        ...attributes,
        genders:
          attributes.genders.indexOf("any gender") !== -1
            ? []
            : [...attributes.genders],
        gendersOther: event.target.value,
      },
    });
  };

  const clearAttributesGendersOther = () => {
    setItem({
      ...item,
      attributes: {
        ...attributes,
        gendersOther: [],
      },
    });
  };

  const toggleAttributesGoal = (goal) => {
    let goalsUpdate = [...attributes.goals];
    let goalsOtherUpdate = attributes.goalsOther;
    const goalsIndex = attributes.goals.indexOf(goal);
    if (goal === "any goal" && goalsIndex === -1) {
      goalsUpdate = [];
      goalsOtherUpdate = [];
    } else if (attributes.goals.indexOf("any goal") !== -1) {
      goalsUpdate.splice(0, 1);
    }
    if (goalsIndex === -1) {
      goalsUpdate.push(goal);
    } else {
      goalsUpdate.splice(goalsIndex, 1);
    }
    setItem({
      ...item,
      attributes: {
        ...attributes,
        goals: goalsUpdate,
        goalsOther: goalsOtherUpdate,
      },
    });
  };

  const setAttributesGoalsOther = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      attributes: {
        ...attributes,
        goals:
          attributes.goals.indexOf("any goal") !== -1
            ? []
            : [...attributes.goals],
        goalsOther: event.target.value,
      },
    });
  };

  const clearAttributesGoalsOther = () => {
    setItem({
      ...item,
      attributes: {
        ...attributes,
        goalsOther: [],
      },
    });
  };

  const toggleAttributesSkill = (skill) => {
    let skillsUpdate = [];
    let skillIndex = -1;
    if (attributes.skills) {
      skillsUpdate = [...attributes.skills];
      skillIndex = attributes.skills.indexOf(skill);
      if (skill === "any skill level" && skillIndex === -1) {
        skillsUpdate = [];
      } else if (attributes.skills.indexOf("any skill level") !== -1) {
        skillsUpdate.splice(0, 1);
      }
    }
    if (skillIndex === -1) {
      skillsUpdate.push(skill);
    } else {
      skillsUpdate.splice(skillIndex, 1);
    }
    setItem({
      ...item,
      attributes: {
        ...attributes,
        skills: skillsUpdate,
      },
    });
  };

  const setAttributesSkillsOther = (event) => {
    event.preventDefault();
    setItem({
      ...item,
      attributes: {
        ...attributes,
        skills:
          attributes.skills.indexOf("any skill") !== -1
            ? []
            : [...attributes.skills],
        skillsOther: event.target.value,
      },
    });
  };

  const clearAttributesSkillsOther = () => {
    setItem({
      ...item,
      attributes: {
        ...attributes,
        skillsOther: [],
      },
    });
  };

  const doneAttributes = () => {
    doneStep("attributes", step);
  };

  const textContentProps = {
    id: id,
    type: type,
    setItem: setItem,
    item: item,
    child: "attributes",
    saveItem: saveItem,
  };

  return (
    <div
      className={`component-section-wrap ${
        doneList && doneList.attributes ? "done" : ""
      } ${
        (!attributes.ages || attributes.ages.length === 0) &&
        (!attributes.agesOther || attributes.agesOther.length === 0) &&
        (!attributes.gender || attributes.gender.length === 0) &&
        (!attributes.genderOther || attributes.genderOther.length === 0) &&
        (!attributes.goals || attributes.goals.length === 0) &&
        (!attributes.goalsOther || attributes.goalsOther.length === 0) &&
        (!attributes.skills || attributes.skills.length === 0) &&
        (!attributes.skillsOther || attributes.skillsOther.length === 0) &&
        (!attributes.personalities || attributes.personalities.length === 0) &&
        (!attributes.personalitiesOther ||
          attributes.personalitiesOther.length === 0) &&
        (!attributes.definition || attributes.definition === "")
          ? "none-selected"
          : ""
      }`}
    >
      <div className="component-section-inner">
        <h2 className="with-help">
          {headerText.attributes[label]}
          <Popup
            hoverable
            hideOnScroll
            position="top right"
            className="popup-help"
            trigger={
              <div className="header-help">
                <i className="icon icon-question-circle" />
              </div>
            }
            header={<p>{helpText.attributes[label]}</p>}
          />
        </h2>

        <TextContent node={0} {...textContentProps} />

        <div
          className={`attributes-section attributes-demographics ${
            (!attributes.ages || attributes.ages.length === 0) &&
            (!attributes.genders || attributes.genders.length === 0) &&
            (!attributes.goals || attributes.goals.length === 0) &&
            (!attributes.skills || attributes.skills.length === 0) &&
            (!attributes.occupations || attributes.occupations.length === 0) &&
            (!attributes.locations || attributes.locations.length === 0)
              ? "empty"
              : ""
          }`}
        >
          <div className="section-grid">
            <div
              className={`attributes-ages ${
                attributes.ages?.length > 0 || attributes.agesOther?.length > 0
                  ? ""
                  : "empty"
              }`}
            >
              <label>What age group?</label>
              <ul className="attributes-list cards-list">
                {Object.keys(itemTemplate.sections.attributes.ages).map(
                  (key) => (
                    <li
                      key={key}
                      className={`card ${
                        itemTemplate.sections.attributes.ages[key]
                      } ${
                        attributes.ages &&
                        attributes.ages.indexOf(
                          itemTemplate.sections.attributes.ages[key]
                        ) !== -1
                          ? "selected"
                          : ""
                      }`}
                      onClick={() =>
                        toggleAttributesAge(
                          itemTemplate.sections.attributes.ages[key]
                        )
                      }
                    >
                      <p>{itemTemplate.sections.attributes.ages[key]}</p>
                    </li>
                  )
                )}
                <li
                  className={`card other ${
                    attributes.agesOther && attributes.agesOther.length > 0
                      ? "selected"
                      : ""
                  }`}
                >
                  <input
                    type="text"
                    id="attributes-ages-other-input"
                    placeholder="Other..."
                    value={attributes.agesOther}
                    onChange={setAttributesAgesOther}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        document
                          .getElementById("attributes-ages-other-input")
                          .blur();
                      }
                    }}
                  />
                  <span
                    className="card-delete"
                    onClick={clearAttributesAgesOther}
                  >
                    <i className="icon icon-cross" />
                  </span>
                </li>
              </ul>
            </div>
            <div
              className={`attributes-genders ${
                attributes.genders?.length > 0 ||
                attributes.genderOther?.length > 0
                  ? ""
                  : "empty"
              }`}
            >
              <label>What's their gender?</label>
              <ul className="attributes-list cards-list">
                {Object.keys(itemTemplate.sections.attributes.genders).map(
                  (key) => (
                    <li
                      key={key}
                      className={`card ${
                        itemTemplate.sections.attributes.genders[key]
                      } ${
                        attributes.genders &&
                        attributes.genders.indexOf(
                          itemTemplate.sections.attributes.genders[key]
                        ) !== -1
                          ? "selected"
                          : ""
                      }`}
                      onClick={() =>
                        toggleAttributesGender(
                          itemTemplate.sections.attributes.genders[key]
                        )
                      }
                    >
                      <p>{itemTemplate.sections.attributes.genders[key]}</p>
                    </li>
                  )
                )}
                <li
                  className={`card other ${
                    attributes.gendersOther &&
                    attributes.gendersOther.length > 0
                      ? "selected"
                      : ""
                  }`}
                >
                  <input
                    type="text"
                    id="attributes-genders-other-input"
                    placeholder="Other..."
                    value={attributes.gendersOther}
                    onChange={setAttributesGendersOther}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        document
                          .getElementById("attributes-genders-other-input")
                          .blur();
                      }
                    }}
                  />
                  <span
                    className="card-delete"
                    onClick={clearAttributesGendersOther}
                  >
                    <i className="icon icon-cross" />
                  </span>
                </li>
              </ul>
            </div>
            <div
              className={`attributes-goals ${
                attributes.goals?.length > 0 ||
                attributes.goalsOther?.length > 0
                  ? ""
                  : "empty"
              }`}
            >
              <label>What are their goals?</label>
              <ul className="attributes-list cards-list">
                {Object.keys(itemTemplate.sections.attributes.goals).map(
                  (key) => (
                    <li
                      key={key}
                      className={`card ${
                        itemTemplate.sections.attributes.goals[key]
                      } ${
                        attributes.goals &&
                        attributes.goals.indexOf(
                          itemTemplate.sections.attributes.goals[key]
                        ) !== -1
                          ? "selected"
                          : ""
                      }`}
                      onClick={() =>
                        toggleAttributesGoal(
                          itemTemplate.sections.attributes.goals[key]
                        )
                      }
                    >
                      <p>{itemTemplate.sections.attributes.goals[key]}</p>
                    </li>
                  )
                )}
                <li
                  className={`card other ${
                    attributes.goalsOther && attributes.goalsOther.length > 0
                      ? "selected"
                      : ""
                  }`}
                >
                  <input
                    type="text"
                    id="attributes-goals-other-input"
                    placeholder="Other..."
                    value={attributes.goalsOther}
                    onChange={setAttributesGoalsOther}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        document
                          .getElementById("attributes-goals-other-input")
                          .blur();
                      }
                    }}
                  />
                  <span
                    className="card-delete"
                    onClick={clearAttributesGoalsOther}
                  >
                    <i className="icon icon-cross" />
                  </span>
                </li>
              </ul>
            </div>
            <div
              className={`attributes-skills ${
                attributes.skills?.length > 0 ||
                attributes.skillsOther?.length > 0
                  ? ""
                  : "empty"
              }`}
            >
              <label>Level of technical skills?</label>
              <ul className="attributes-list cards-list">
                {Object.keys(itemTemplate.sections.attributes.skills).map(
                  (key) => (
                    <li
                      key={key}
                      className={`card ${
                        itemTemplate.sections.attributes.skills[key]
                      } ${
                        attributes.skills &&
                        attributes.skills.indexOf(
                          itemTemplate.sections.attributes.skills[key]
                        ) !== -1
                          ? "selected"
                          : ""
                      }`}
                      onClick={() =>
                        toggleAttributesSkill(
                          itemTemplate.sections.attributes.skills[key]
                        )
                      }
                    >
                      <p>{itemTemplate.sections.attributes.skills[key]}</p>
                    </li>
                  )
                )}
                <li
                  className={`card other ${
                    attributes.skillsOther && attributes.skillsOther.length > 0
                      ? "selected"
                      : ""
                  }`}
                >
                  <input
                    type="text"
                    id="attributes-skills-other-input"
                    placeholder="Other..."
                    value={attributes.skillsOther}
                    onChange={setAttributesSkillsOther}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        document
                          .getElementById("attributes-skills-other-input")
                          .blur();
                      }
                    }}
                  />
                  <span
                    className="card-delete"
                    onClick={clearAttributesSkillsOther}
                  >
                    <i className="icon icon-cross" />
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <p className="section-empty">
            No attributes details, click here to enter them.
          </p>
        </div>
        <div
          className={`attributes-section attributes-personalities ${
            attributes.personalities?.length > 0 ||
            attributes.personalitiesOther?.length > 0
              ? ""
              : "empty"
          }`}
        >
          <label>What personality traits do they have?</label>
          <ul className="attributes-list cards-list">
            {Object.keys(itemTemplate.sections.attributes.personalities).map(
              (key) => (
                <li
                  key={key}
                  className={`card ${
                    itemTemplate.sections.attributes.personalities[key]
                  } ${
                    attributes.personalities &&
                    attributes.personalities.indexOf(
                      itemTemplate.sections.attributes.personalities[key]
                    ) !== -1
                      ? "selected"
                      : ""
                  }`}
                  onClick={() =>
                    toggleAttributesPersonalities(
                      itemTemplate.sections.attributes.personalities[key]
                    )
                  }
                >
                  <p>{itemTemplate.sections.attributes.personalities[key]}</p>
                </li>
              )
            )}
            <li
              className={`card other ${
                attributes.personalitiesOther &&
                attributes.personalitiesOther.length > 0
                  ? "selected"
                  : ""
              }`}
            >
              <input
                type="text"
                id="attributes-personalities-other-input"
                placeholder="Other..."
                value={attributes.personalitiesOther}
                onChange={setAttributesPersonalitiesOther}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    document
                      .getElementById("attributes-personalities-other-input")
                      .blur();
                  }
                }}
              />
              <span
                className="card-delete"
                onClick={clearAttributesPersonalitiesOther}
              >
                <i className="icon icon-cross" />
              </span>
            </li>
          </ul>
        </div>

        <div
          className={`attributes-section attributes-definition ${
            !attributes.definition || attributes.definition === ""
              ? "empty"
              : "selected"
          }`}
        >
          <label>What else should we know about this persona?</label>
          <div className="attributes-definition-wrap">
            <TextareaAutosize
              id="attributes-definition-textarea"
              minRows={1}
              maxRows={12}
              type="text"
              name="attributes-definition"
              style={{ lineHeight: 1.67 }}
              value={attributes.definition}
              className="attributes-textarea"
              placeholder="Further describe their behaviors, needs, expectations, pain points, etc."
              onChange={setAttributesDefinition}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  document
                    .getElementById("attributes-definition-textarea")
                    .blur();
                }
              }}
            />
            <span className="card-selected-wrap">
              <span className="card-selected">
                <i className="icon icon-check" />
              </span>
            </span>
          </div>
        </div>
        <p className="section-empty">
          No screens added, click here to add them.
        </p>

        <TextContent node={1} {...textContentProps} />
      </div>
      <div className="section-btn-done">
        <div className="btn btn-done" onClick={doneAttributes}>
          <i className="icon icon-checkmark-circle" />
        </div>
      </div>
      <div className="section-edit-wrap" onClick={editAttributes}>
        <span className="section-edit-icon component-section-inner">
          <i className="icon icon-edit" />
        </span>
      </div>
    </div>
  );
};

export default Attributes;
